import {useTheme} from '@mui/material';

import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {formatText, getAllMonths, getCityAndUfByRegex, getUfName} from 'presentation/utils';
import {UsePrintTemplateProps} from './types';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {isAdvanceDiagnosticsAppointment} from 'presentation/modules/myAppointments/utils/isAdvanceDiagnosticsAppointment';

export function usePrintTemplate({bookedAppointment, flowType}: UsePrintTemplateProps) {
	const {isMobile, isTablet} = useMediaQueries();
	const {iconName} = useBookingTheme({flowType});
	const {colors} = useTheme();

	const {isEnabled: isUploadFileTeleFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_UPLOAD_FILE_TELE,
	);
	const {isEnabled: isAdvanceDiagnosticsExamsJourneyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_ADVANCE_DIAGNOSTICS_EXAMS_JOURNEY,
	);

	const isTelehealth = flowType === FlowEnum.TELEHEALTH;
	const isOdonto = flowType === FlowEnum.ODONTO;
	const isSurgery = flowType === FlowEnum.SURGERY;

	const {
		clinicName,
		formattedAddress,
		formattedDateWithWeekday,
		hour,
		date,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
		bookingType,
		unitCode,
	} = bookedAppointment;

	const isAdvanceDiagnosticsExam = isAdvanceDiagnosticsAppointment({
		appointment: {bookingType, unitCode},
		isAdvanceDiagnosticsExamsJourneyEnabled,
	});

	const [day, month] = date.split(' ')[0].split('/');
	const months = getAllMonths();
	const monthName = months[Number(month) - 1].slug;

	const {district, city, uf} = getCityAndUfByRegex(formattedAddress);

	const showProtocolCard = !isTelehealth && !isSurgery && protocolNumber;

	const showAddress = () => {
		if (isOdonto) {
			return {
				first: formatText(district),
				second: `${city}/${getUfName(uf)}`,
			};
		}
		return {
			first: formatText(city),
			second: `${getUfName(uf)}`,
		};
	};

	return {
		isMobile,
		isTablet,
		iconName,
		colors,
		isTelehealth,
		clinicName,
		formattedAddress,
		formattedDateWithWeekday,
		hour,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
		showAddress,
		showProtocolCard,
		day,
		monthName,
		isUploadFileTeleFeatureFlagEnabled,
		isAdvanceDiagnosticsExam,
	};
}
